import { render, staticRenderFns } from "./FloatingMessagesWrapper.vue?vue&type=template&id=f4fb5012&"
import script from "./FloatingMessagesWrapper.vue?vue&type=script&lang=js&"
export * from "./FloatingMessagesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports